import React from "react";
import { X } from "lucide-react";

// « × » des cartes intelligentes : masque la carte jusqu'au prochain contenu nouveau.
export const DismissX = ({ onClick, testId, label = "Masquer" }) => {
  if (!onClick) return null;
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(); }}
      aria-label={label}
      title={label}
      className="h-7 w-7 -mr-1 shrink-0 rounded-full grid place-items-center transition-colors hover:bg-[rgba(0,0,0,0.06)]"
      style={{ color: "var(--yalola-text-muted)" }}
      data-testid={testId}
    >
      <X size={15} />
    </button>
  );
};
